import { Decodable } from "./_decodable";
import { Product } from "./product";
import { Unit } from "./unit";
import { DetailsConfigField } from "./details-config";

class Item extends Decodable {
    id: number;
    ordem: number;
    name: string;
    type: number;
    unitId: number = 1;
    perUnit: number = 0;
    total: number = 0;
    quantity: number = 0;
    shouldSave: boolean;
    productId: number;
    // Campos de snapshot do produto associados ao item da proposta
    productCode?: string;
    productImage?: string;
    productDescription?: string;
    productCategoryName?: string;
    productStockQuantity?: number;
    productStockControlEnabled?: boolean;
    productEstoqueMinimo?: number;
    productUnit?: string;
    product?: Product;
    
    // Configuração de exibição de detalhes do item
    // Null/undefined = usa configuração global do LocalStorage (definida pelo usuário no header)
    // Array definido = usa configuração específica deste item (sobrescreve a global)
    detailsConfig?: DetailsConfigField[];
    // ORCA-1937: default (padrão do orçamento), custom (detailsConfig) ou none
    detailsMode?: 'default' | 'custom' | 'none' | null;
    hideValue: boolean = false;

    protected _map = {
        createdAt: (e) => this.parseDate(e),
        updatedAt: (e) => this.parseDate(e),
        detailsConfig: (e) => DetailsConfigField.parse(e),
        hideValue: (e) => !!e,
        product: (e) => Product.parse(e),
    };

    public static fromDefaultUnit(unit: Unit):Item {
        var item = new Item();
        item.unitId = unit.id;
        item.perUnit = 0;
        item.type = unit.type;
        return item;
    }
}

export { Item };
